<template>
  <div>
    <custom-popup
      id="add-archive-card"
      v-model="dialog"
      :cons="cons"
      max-width="700"
      :hideConfirm="true"
      :persistent="false"
    >
      <v-card flat>
        <!-- بخش اسکرول و نمایش لیست -->
        <v-card-text
          style="max-height: 460px; min-height: 200px; overflow-y: auto;"
          class="pt-3 px-3"
        >
          <!-- در صورتی که لیست خالی باشد -->
          <div
            v-if="!archivedList || archivedList.length === 0"
            class="text-center grey--text my-10 py-6"
          >
            <v-icon size="56" color="grey lighten-2">mdi-archive-off-outline</v-icon>
            <div class="mt-3 text-body-2 font-weight-medium">
              هیچ کارتی در بایگانی وجود ندارد.
            </div>
          </div>

          <!-- لیست کارت‌های بایگانی شده -->
          <v-row v-else dense>
            <v-col
              v-for="(card, index) in archivedList"
              :key="card.id || index"
              cols="12"
            >
              <v-card outlined class="pa-3 rounded-lg grey lighten-5">
                <div class="d-flex justify-space-between align-center">
                  <div style="min-width: 0">
                    <div class="font-weight-bold text-subtitle-2 text-truncate">
                      {{ card.bank_name || 'کیوکارت' }}
                    </div>
                    <div class="text-caption grey--text text--darken-1 ltr-text text-left mt-1">
                      {{ formatCardNumber(card.cart_number) }}
                    </div>
                    <div v-if="card.owner_name" class="text-caption text-truncate mt-1">
                      {{ card.owner_name }}
                    </div>
                  </div>

                  <!-- دکمه بازیابی -->
                  <v-btn
                    small
                    class="btn-refund rounded-lg"
                    @click="restoreCard(index)"
                  >
                    <v-icon left small>mdi-restore</v-icon>
                    بازیابی
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- فوتر پاپ‌آپ -->
        <v-divider />
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ArchivedCardsDialog",

  props: {
    // دریافت مستقیم لیست از والد
    archivedList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      dialog: false,
      cons: { title: "لیست کارت‌های بایگانی شده" },
    };
  },

  methods: {
    open() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    restoreCard(index) {
      // آیتم از لیست بایگانی برداشته می‌شود
      const restoredItem = this.archivedList[index];

      // خبر دادن به والد برای حذف از archivedList و افزودن به localCards
      this.$emit("restore", {
        index,
        item: restoredItem,
      });

      this.$toast.success("کارت با موفقیت بازیابی شد.");

      // اگر بعد از بازیابی کارتی باقی نماند، پاپ‌آپ بسته می‌شود
      if (this.archivedList.length <= 1) {
        this.dialog = false;
      }
    },

    formatCardNumber(value) {
      if (!value) return "";
      const rawValue = value.toString().replace(/\D/g, "");
      const truncated = rawValue.slice(0, 16);
      return truncated.replace(/(\d{4})/g, "$1 ").trim();
    },
  },
});
</script>

<style scoped>
.ltr-text {
  direction: ltr;
  display: inline-block;
}
</style>
